module.exports = __webpack_public_path__ + "img/stock7.16a6578c.png";